<template>
  <header class="entry-layout-header">
    <span class="entry-layout-header-logo">
      <img :src="logo" :style="logoStyle">
    </span>
    <div class="entry-layout-header-menus">
      <!-- :visible="true" -->
      <a-dropdown class="entry-dropdown" placement="bottomLeft">
        <div class="entry-dropdown__name">
          <a-icon type="appstore" theme="filled" />
          <span style="margin-left:8px;">{{ (menuInfo && menuInfo.tab) || (menusActiveID && menusActiveID === '__HISTORY__' && i18nRender('layouts.commonmenu')) || i18nRender('layouts.application') }}</span>
          <a-icon type="caret-down" style="margin-left:5px;font-size:12px" />
        </div>
        <template v-if="menus.length === 0" #overlay>
          <div style="padding:10px 15px;background:#f8f8f8;text-align:center;">
            <a-empty :description="i18nRender('layouts.text.undefined')" />
          </div>
        </template>
        <template v-else #overlay>
          <a-menu slot="overlay" :selectedKeys="['']" @click="handleMenusChange">
            <!-- 常用菜单 -->
            <a-menu-item key="__HISTORY__">
              <div class="entry-dropdown-menu">
                <div class="entry-dropdown-menu__hd">
                  <!-- <a-icon type="thunderbolt" :theme="menusActiveID && menusActiveID === '__HISTORY__' ? 'filled' : 'outlined'" /> -->
                  <icon-font type="gb-icon-icon_liwu_w" />
                </div>
                <div class="entry-dropdown-menu__bd">{{ i18nRender('layouts.commonmenu') }}</div>
                <div class="entry-dropdown-menu__ft">
                  <span style="color:#666666; font-weight:bold" v-if="menusActiveID && menusActiveID === '__HISTORY__'">{{ i18nRender('layouts.current') }}</span>
                  <span style="color:#077bfc;" v-else><a-icon type="swap" /> {{ i18nRender('layouts.switch', []) }}</span>
                </div>
              </div>
            </a-menu-item>
            <!-- 角色自定义菜单 -->
            <a-menu-item v-for="menu in customMenus" :key="menu.key">
              <div class="entry-dropdown-menu">
                <div class="entry-dropdown-menu__hd">
                  <icon-font type="gb-icon-kecheng-copy"  v-if="menu.menuType === 1"  />
                  <icon-font type="gb-icon-zidingyi" v-else/>
                </div>
                <div class="entry-dropdown-menu__bd">{{ menu.tab }}</div>
                <!-- {{menu}} -->
                <div class="entry-dropdown-menu__ft">
                  <span>
                    <a-icon type="edit" v-demo:[menu]="'handleCustom'" />
                  </span>
                  <span>
                    <!-- @click.stop="handleDeleteMenu(menu)" -->
                    <a-icon type="delete" v-demo:[menu]="'handleDeleteMenu'" />
                  </span>
                  <span style="color:#666666; font-weight:bold" v-if="menusActiveID && menusActiveID === menu.key">{{ i18nRender('layouts.current') }}</span>
                  <span style="color:#077bfc;" v-else><a-icon type="swap" /> {{ i18nRender('layouts.switch', []) }}</span>
                </div>
              </div>
            </a-menu-item>
            <!-- 新增自定义场景 -->
            <template >
              <a-menu-divider rootPrefixCls="home-ant-dropdown-menu" />
              <a-menu-item key="addCustomMenus">
                <div class="entry-dropdown-menu" style="justify-content: center;">
                  <a-button size="small" class="entry-dropdown-menu__btn" type="link" icon="plus-circle">{{ i18nRender('layouts.customscene', []) }}</a-button>
                </div>
              </a-menu-item>
            </template>
          </a-menu>
        </template>
      </a-dropdown>
    </div>
    <a-divider type="vertical" />
    <entry-menus v-if="selectedMenus" :menu="selectedMenus" :currentLang="currentLang" @click="handleMenuChange" />
    <div class="entry-layout-header-nav">
      <div class="entry-layout-header-nav__main">
        <div
          v-for="tab in customTabs[0]"
          :key="tab.key"
          class="entry-layout-header-nav__item"
          @click="handleMenuChange(tab.key)"
        >{{ tab | menuLocalName }}</div>
      </div>
      <div class="entry-layout-header-nav__extra">
        <!-- 更多菜单 -->
        <a-dropdown class="entry-dropdown" placement="bottomLeft" v-if="customTabs[1].length">
          <div class="entry-layout-header-nav__btn"> <a-icon type="dash" /> </div>
          <template #overlay>
            <a-menu slot="overlay" :selectedKeys="['']" @click="handleMenuClick">
              <a-menu-item v-for="menu in customTabs[1]" :key="menu.key">
                <div class="entry-dropdown-menu">
                  <div class="entry-dropdown-menu__bd">{{ menu | menuLocalName }}</div>
                </div>
              </a-menu-item>
            </a-menu>
          </template>
        </a-dropdown>
        <!-- 自定义菜单编辑按钮 -->
        <div
          v-if="menusActiveID && menuInfo"
          class="entry-layout-header-nav__btn"
          v-demo:[menuInfo]="'handleCustom'"
        >
          <span style="font-size:24px;vertical-align:-2px;line-height:1;">+</span>
        </div>
      </div>
    </div>
    <slot name="rightContentRender" />
  </header>
</template>

<script>
import EntryMenus from './EntryMenus'
import { i18nRender } from '@/locales'

export default {
  name: 'EntryLayoutHeader',
  components: {
    EntryMenus
  },
  props: {
    subjectMode: {
      type: [Number, Object],
      default: () => null
    },
    menus: {
      type: Array,
      default: () => []
    },
    customTabs: {
      type: [Array, Array],
      default: () => [[], []]
    },
    customMenus: {
      type: Array,
      default: () => []
    },
    menusActiveID: {
      type: String,
      default: ''
    },
    currentLang: {
      type: String,
      default: 'zh_CN'
    }
  },
  data () {
    return {
      logo: 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABkAAAAdCAMAAABopjdHAAAAQlBMVEUAAAD///////////////////////////////////////////////////////////////////////////////////8IX9KGAAAAFXRSTlMAgMDw4BBgIFAwsECR0aBwqphYyIhPo2vqAAABDElEQVQoz22S3XbEIAiEg6DxP7vbzvu/agXjadJ0LhLgQ8ajbheVz779pz2jM/lH3ROADkj4A4IArn5yA1y6Gji4eK49BN0vgw6Ol7kVTBYRg9N9NCCjNeMEPlCmuBCOzQG2ncgAZrO10yBO40Q4FdTaiIVUCUtl5N2IerB8n3WWrLOVuGnZ3g1Aq8JVW5Voi42KK9CtKqmrwPsYsoxs2iKoG9+ImKGK508LSQn0usRqb/vSyA8lFiWb022JnnQz0jQMA7EoSNY4SH5Jt7ug6oB53V6+XrQVOypTKWkGbs7c7WAv8s6WWm+D+31PUdBXZv45aJoOQSu3CRWnODweojOgBg8VQZ4GT6Vr8gOUzBNDdAAY6QAAAABJRU5ErkJggg==',
      logoStyle: { display: 'block', height: '30px' },
      selectedKeys: [],
      systems: [
        { name: '运营', code: 'AMAZON_OPERATE' },
        { name: '刊登', code: 'SYS_LISTING' }
      ],
      systemCode: this.$route.params.systemCode
    }
  },
  computed: {
    menuInfo () {
      const { menus, customMenus, menusActiveID } = this
      const activeMenu = menus.find(menu => menusActiveID && menusActiveID === menu.key) ||
                         customMenus.find(menu => menusActiveID && menusActiveID === menu.key)
      return activeMenu
    },
    selectedMenus () {
      const { menus, menusActiveID } = this
      return menus.find(menu => menusActiveID && menusActiveID === menu.key)
    }
  },
  methods: {
    i18nRender,
    back () {
      window.location.href = ((process.env.SSO_ENV || '') + '/#/user/home').replace(/^\/?/, '/')
      return false
    },
    toSystem (systemCode) {
      const { serviceId } = this.$route.params
      window.open(`/entry/${serviceId}/${systemCode}`, '_self')
    },
    handleMenusChange ({ key }) {
      switch (key) {
        case 'addCustomMenus':
          if (this.customMenus.length >= 30) {
            this.$notification.warning({
              message: i18nRender('notification-modal.title.prompt'),
              description: i18nRender('notification-modal.content.maxcustomscene')
            })
            return
          }
          this.$emit('menusadd', key)
          break
        default:
          this.$emit('menuschange', key)
      }
    },
    handleMenuChange (key) {
      this.$emit('menuchange', key)
    },
    handleMenuClick ({ key }) {
      this.$emit('menuchange', key)
    },
    handleCustom (info) {
      this.$emit('custommenu', info || this.menuInfo)
    },
    handleDeleteMenu (info) {
      if (this.menusActiveID === `c_${info.menuId}`) {
        return this.$message.warning(i18nRender('layouts.customscene.currentNoDel'))
      }
      this.$confirm({
        icon: 'info-circle',
        title: i18nRender('notification-modal.title.prompt'),
        content: i18nRender('notification-modal.content.delete.customscene'),
        okText: i18nRender('form-modal.delete'),
        cancelText: i18nRender('form-modal.cancel'),
        onOk: () => {
          return this.$store.dispatch('entry/RemoveCustomMenu', info.menuId).then(data => {
            this.$message.success(data.message)
          })
        }
      })
    }
  }
}
</script>

<style lang="less">
.entry-layout-header {
  padding: 0 10px;
  display: flex;
  align-items: center;
  height: 42px;
  line-height: 42px;
  // background: #060747 url('../../assets/bg-erp-head.png') no-repeat 100% 100%;
  background: #1E1E28 url('../../assets/bg-erp-head.png') no-repeat 100% 100%;
  z-index: 55;
}

.entry-layout-header-logo {
  margin-right: 20px;
  display: inline-block;
}

.entry-layout-header-nav {
  display: inline-flex;
  flex: 1;
  min-width: 0;
  font-size: 12px;
  line-height: 42px;
  height: 42px;

  &__main {
    display: inline-flex;
    white-space: nowrap;
    overflow: hidden;
  }

  &__item {
    padding: 0 10px;
    color: #fff;
    cursor: pointer;

    &--active,
    &:hover {
      background: rgba(255, 255, 255, 0.25);
    }
  }

  &__extra {
    flex: 1 0 auto;
  }

  &__btn {
    padding: 0 7px;
    display: inline-block;
    height: 42px;
    line-height: 42px;
    color: #ffffff;
    cursor: pointer;

    &:hover {
      background: rgba(255, 255, 255, 0.25);
    }

    .anticon {
      vertical-align: baseline;
    }
  }
}

.entry-dropdown {
  color: #ffffff;

  &__name {
    padding: 0 14px;
    display: block;
    height: 42px;
    line-height: 42px;
    overflow: hidden;
    position: relative;
    cursor: pointer;
  }

  &__name.@{ant-prefix}-dropdown-open {
    background: rgba(255, 255, 255, .25);
  }
}

.entry-dropdown-menu {
  width: 246px;
  display: flex;
  align-items: center;
  font-size: 12px;
  color: #333;

  .@{ant-prefix}-avatar {
    display: block;
    width: 14px;
    height: 14px;
    background-color: transparent;
    color: inherit;
    font-size: inherit;
    line-height: 14px;
  }

  &__hd {
    margin-right: 8px;
    position: relative;
    font-size: 13px;
    text-align:left;
  }
  &__bd {
    flex: 1;
    min-width: 0;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;

    .@{ant-prefix}-dropdown-menu-item-selected & {
      font-weight: 750;
    }
  }
  &__ft {
    margin-left: 8px;
    & > span {
      margin-left: 10px;
      color: rgb(86, 129, 244);
      display: inline-block;
      vertical-align: top;
      .anticon {
        font-size: 13px;
      }
      &:last-child {
        width: 50px;
        text-align: center;
      }
    }
  }
  &__btn {
    color: #333 !important;
    font-size: 12px !important;
    line-height: 18px !important;
    height: auto !important;
  }
}
</style>
